/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { HttpClient, RequestParams } from "../http-client";
import { GetFirmwareData } from "../models";

export class Firmware<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags ota
   * @name GetFirmware
   * @summary Get firmware info
   * @request GET:/firmware
   * @secure
   */
  getFirmware = (params: RequestParams = {}) =>
    this.http.request<GetFirmwareData, void>({
      path: `/firmware`,
      method: "GET",
      secure: true,
      ...params,
    });
}
